<!-- 任务 -->
<template>
  <div :class="$style.tasks">
    <template v-if="userName">
      <!-- 查看奖励 -->
      <button :class="$style['btn-view-reward']" @click="onViewPrizeRecords" />
      <!-- 剩余抽奖次数 -->
      <div :class="$style['remaining-times']">
        <span>{{ lotteryCount }}</span>
      </div>
    </template>
    <!-- 任务列表 -->
    <ul :class="$style['tasks-list']">
      <!-- 邀请任务 -->
      <li>
        <div>
          <p :class="$style['tasks-desc']">
            邀请新道友进入页面登录ID
            <template v-if="userName">
              <br />
              已有
              <em>{{ inviteCount }}名</em>
              好友接受邀请
            </template>
          </p>
          <p :class="$style['tasks-tip']">
            新道友指注册时间在6月11日后或者30天<br />以上未登录的道友，任务最多可完成3次
          </p>
        </div>
        <div
          :class="[
            $style['tasks-btn'],
            { [$style.disabled]: isInviteCompleted }
          ]"
        >
          <button :disabled="isInviteCompleted" @click="onInvite">
            {{ isInviteCompleted ? "任务完成" : "立即邀请" }}
          </button>
          <p><em>抽奖次数+2/每人</em></p>
        </div>
      </li>
      <!-- 签到任务 -->
      <li>
        <div>
          <p :class="$style['tasks-desc']">
            每日进入活动页面签到
            <template v-if="userName">
              <br />
              已签到
              <em>{{ signinDays }}</em>
              天
            </template>
          </p>
          <p :class="$style['tasks-tip']">
            本任务最多可完成7次
          </p>
        </div>
        <div
          :class="[
            $style['tasks-btn'],
            { [$style.disabled]: isSigninToday || isCompleteSignin }
          ]"
        >
          <button
            :disabled="isSigninToday || isCompleteSignin"
            @click="onSignIn"
          >
            {{ isSigninToday || isCompleteSignin ? "任务完成" : "立即完成" }}
          </button>
          <p><em>抽奖次数+1/每日</em></p>
        </div>
      </li>
      <!-- 领取礼包任务 -->
      <li>
        <div>
          <p :class="$style['tasks-desc']">
            629进入活动页面领取礼包
          </p>
          <p :class="$style['tasks-tip']">
            本任务最多可完成1次
          </p>
        </div>
        <div
          :class="[
            $style['tasks-btn'],
            { [$style.disabled]: isGiftTaskCompleted }
          ]"
        >
          <button :disabled="isGiftTaskCompleted" @click="onClaimGift">
            {{ isGiftTaskCompleted ? "任务完成" : "立即完成" }}
          </button>
          <p><em>抽奖次数+2/每次</em></p>
        </div>
      </li>
    </ul>
    <!-- 邀请链接 -->
    <the-invite-link
      v-if="userName"
      ref="inviteLink"
      :invite-prefix="currentInvitePrefix"
      :rules-config="rulesConfig"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import TheInviteLink from "@/components/TheInviteLink";
import { collectAward, signin, collectSigninAward } from "@/api";
import { getQueryString } from "@/utils";

export default {
  name: "TheTasks",
  components: { TheInviteLink },
  data() {
    return {
      currentInvitePrefix: ""
    };
  },
  props: {
    inviteTextList: {
      type: Array,
      default: () => []
    },
    rulesConfig: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters([
      "user",
      "lotteryCount",
      "lotteryGiftId",
      "isGiftClaimed",
      "isLotteryGiftClaimed",
      "isDebug",
      "isSigninToday",
      "signinDays",
      "signinList",
      "isCompleteSignin",
      "inviteCount"
    ]),
    userName() {
      return this.user && this.user.role_name;
    },
    /** 礼包任务是否已完成 */
    isGiftTaskCompleted() {
      return this.isGiftClaimed && this.isLotteryGiftClaimed;
    },
    /** 邀请任务是否已完成 */
    isInviteCompleted() {
      return this.inviteCount >= 3;
    }
  },
  methods: {
    ...mapActions(["setOwnedGifts", "setLotteryCount", "setSigninInfo"]),
    /** 查看获奖记录 */
    onViewPrizeRecords() {
      this.$emit("show-prize-records");
    },
    /** 邀请 */
    onInvite() {
      if (!this.userName) {
        this.$emit("login");
        return;
      }
      // 随机取一条邀请文案
      if (this.inviteTextList.length) {
        const index = Math.floor(Math.random() * this.inviteTextList.length);
        this.currentInvitePrefix = this.inviteTextList[index];
      }
      this.$nextTick(() => {
        this.$refs.inviteLink.show();
      });
    },
    /** 签到 */
    async onSignIn() {
      if (!this.userName) {
        this.$emit("login");
        return;
      }

      // 获取当天签到项
      const todaySigninItem = this.signinList[this.signinDays];

      let giftId;
      if (todaySigninItem.is_sign !== 1) {
        // 今日未签到
        const { data = {} } = await signin(
          this.isDebug && { test_time: getQueryString("t") }
        );
        if (data.sign_day_data) {
          const giftItem = Object.values(data.sign_day_data).find(
            item => item.is_sign === 1 && item.is_award !== 1
          );
          giftId = giftItem.award_id;
          this.setSigninInfo(data);
        }
      } else {
        // 今日已签到
        giftId = todaySigninItem.award_id;
      }

      if (!giftId) {
        return;
      }

      // 开始领奖
      const collectRes = await collectSigninAward(giftId);
      if (collectRes.code === 0) {
        // 刷新用户数据（initUser内部会调用initSignin）
        this.$emit("refresh-user");
      }
    },
    /** 领取礼包 */
    async onClaimGift() {
      if (!this.userName) {
        this.$emit("login");
        return;
      }
      // 已领基础礼包但未领抽奖次数礼包，直接领取405
      if (this.isGiftClaimed && !this.isLotteryGiftClaimed) {
        const { code, data } = await collectAward(this.lotteryGiftId);
        if (code === 0) {
          this.setOwnedGifts(this.lotteryGiftId);
          // 更新抽奖次数
          this.setLotteryCount(data && data.extra && data.extra.residue);
        }
        return;
      }
      // 两个都未领取，跳转到回归福利选项卡并定位到TheWelfare
      this.$emit("go-welfare");
    }
  }
};
</script>

<style lang="less" module>
.tasks {
  .background-fill("./images/tasks-bg.jpg");

  position: relative;
  height: 11.8rem;
  padding-top: 3.06rem;

  &-list {
    width: 7.1rem;
    margin-left: 2.75rem;

    li {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 2.09rem;
      margin-bottom: 0.56rem;
    }

    em {
      color: #ae331b;
    }
  }

  &-desc {
    font-size: 0.35rem;
    color: #67310d;
    line-height: 1.2;
  }

  &-tip {
    margin-top: 0.04rem;
    color: #fe6c00;
    line-height: 1.5;
  }

  &-btn {
    .size(2.64rem, 1.24rem);
    .background-fill("./images/task-btn.png");

    position: relative;

    button {
      .size(2.15rem, 0.7rem);

      position: absolute;
      top: 0.18rem;
      left: 0.41rem;
      font-size: 0.3rem;
      color: #cb6400;
    }

    &.disabled {
      background-image: url("./images/task-btn-disabled.png");

      button {
        color: #816d49;
      }
    }

    p {
      position: absolute;
      bottom: -0.15rem;
      right: 0.05rem;
      width: 2.24rem;
      text-align: center;
      text-shadow: 3px 0 0 #feffeb, -3px 0 0 #feffeb, 0 3px 0 #feffeb,
        0 -3px 0 #feffeb, 3px 3px 0 #feffeb, -3px -3px 0 #feffeb,
        3px -3px 0 #feffeb, -3px 3px 0 #feffeb;
    }
  }
}

/* 查看奖励按钮 */
.btn-view-reward {
  .size(3.51rem, 1.63rem);
  .background-fill("./images/btn-view-reward.png");

  position: absolute;
  top: 0.1rem;
  right: 0.3rem;
}

.remaining-times {
  .size(3.08rem, 0.37rem);
  .background-fill("./images/remaining-times.png");

  position: absolute;
  top: 2.06rem;
  right: 0.65rem;
  font-size: 0.45rem;
  color: #f0110f;

  span {
    position: absolute;
    top: -0.14rem;
    right: 0.35rem;
    width: 0.7rem;
    text-align: center;
    font-weight: 700;
  }
}
</style>
